import script from "./service.vue?vue&type=script&setup=true&lang=js"
export * from "./service.vue?vue&type=script&setup=true&lang=js"

import "./service.vue?vue&type=style&index=0&id=9b0cb952&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b0cb952"]])

export default __exports__